export default "__VITE_ASSET__CLauCwgd__"